<!--
 * @Description: 优惠列表弹窗
 * @Author: yeqing
 * @Date: 2021-11-10 13:35:30
 * @LastEditTime: 2021-11-24 15:31:25
 * @LastEditors: gjc
-->
<template>
  <div class="couponList">
    <div class="title">可用优惠券</div>
    <div class="scroll_box">
      <div class="item" v-for="(item, index) in couponList" :key="item.id" :class="checkIndex === index ? 'active' : ''" v-show="isShow(item)">
        <svg-icon icon-class="coupon_bg" class="coupon_bg" />
        <div class="amount" v-if="item.couponType == 1">{{ item.discountRatio / 10 }}折</div>
        <div class="amount" v-else><span>￥</span>{{ item.discountAmount / 100 }}</div>
        <div>
          <div class="discount" v-if="item.couponType == 1">
            满<span>￥{{ item.demandAmount / 100 }}</span
            >享{{ item.discountRatio / 10 }}折
          </div>
          <div class="discount" v-else-if="item.couponType == 3">
            满<span>￥{{ item.demandAmount / 100 }}</span
            >减{{ item.discountAmount / 100 }}
          </div>
          <div class="discount" v-else>
            <span>￥{{ item.discountAmount / 100 }}</span
            >代金券
          </div>
          <div class="desc">仅{{ productScope(item.productScope) }}使用</div>
        </div>
        <a-checkbox @change="onChange(index, $event)" class="checkbox" :checked="checkIndex === index"></a-checkbox>
      </div>
    </div>
    <div class="trangle"></div>
  </div>
</template>
<script>
export default {
  props: {
    couponList: {
      type: Array,
      default: () => []
    },
    amount: {
      type: Number,
      default: 0
    },
    // 0:默认选中第一张,'':默认不选
    checkIndex: {
      type: Number || String,
      default: 0
    }
  },
  methods: {
    onChange(index, e) {
      let selectedIndex = e.target.checked ? index : ''
      this.$emit('update:checkIndex', selectedIndex)

      // 如果优惠券金额大于总费用时需要弹窗提示"该优惠券您已使用，多余优惠金额不返还，建议选择其他优惠券或继续使用"
      const { couponList, amount } = this
      let discount = 0
      if (couponList[index].couponType == 1) {
        discount = ((1 - couponList[index].discountRatio * 0.01) * amount).toFixed(2)
      } else {
        discount = (couponList[index].demandAmount * 0.01).toFixed(2)
      }
      if (Number(discount) > amount && e.target.checked) {
        this.$info({
          title: '该优惠券您已使用，多余优惠金额不返还，建议选择其他优惠券或继续使用',
          onOk() {}
        })
      }

      this.$emit('onSelect', selectedIndex)
    },
    // 根据门槛判断是否显示优惠券
    isShow(item) {
      if (!item.demandAmount) {
        return true
      } else {
        if (item.demandAmount / 100 > this.amount) {
          return false
        } else {
          return true
        }
      }
    },

    // 格式化优惠券使用场景
    productScope(data) {
      return JSON.parse(data).join(',')
    }
  }
}
</script>
<style lang="less" scoped>
.couponList {
  width: 400px;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 2px;
  padding: 20px;
  position: relative;
  text-align: left;
  .scroll_box {
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .scroll_box::-webkit-scrollbar {
    width: 0px;
  }

  .title {
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .item {
    display: flex;
    width: 360px;
    height: 70px;
    background: #ffffff;
    border-radius: 3px;
    border: 1px solid #eeeeee;
    align-items: center;
    position: relative;
    margin-top: 10px;
    .amount {
      width: 94px;
      height: 68px;
      line-height: 68px;
      font-size: 24px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #ffffff;
      text-align: center;
      // background-image: url('~@/assets/images/coupon_bg.png');
      margin-right: 14px;
      z-index: 9;
      span {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .coupon_bg {
      width: 94px;
      height: 68px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .discount {
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 14px;
      span {
        color: #ff6d33;
      }
    }
    .desc {
      width: 250px;
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 14px;
      margin-top: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .checkbox {
      position: absolute;
      top: 6px;
      right: 6px;
      line-height: 1.5;
    }
    &:hover {
      border: 1px solid #0072f7;
    }
  }
  .active {
    border: 1px solid #0072f7;
  }
  .trangle {
    width: 0px;
    height: 0px;
    border: 9px solid #fff;
    border-top-color: #fff;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    position: absolute;
    bottom: -17px;
    right: 103px;
  }
}
</style>
